<!-- @format -->

<template>
  <div>
    <!-- faq search section -->
    <section id="faq-search-filter">
      <b-card
          no-body
          class="faq-search"
          :style="{
          backgroundImage: `url(${require('@/assets/images/banner/banner.png')})`,
        }"
      >
        <b-card-body class="text-center"
                     style="height:130px;padding: 0!important;display: flex; align-items: center; justify-content: center;"
        >
          <h2 class="text-primary"/>
          <b-card-text class="mb-2"/>

          <!-- form -->
          <b-form
              class="faq-search-input"
              style="display: flex; align-items: center; justify-content: center;"
              @submit.prevent
          >
            <b-dropdown id="dropdown-1" :text="value" class="m-md-2" style="margin-left: 0!important;">
              <b-dropdown-item
                  v-for="(categoryObj, categoryName) in faqData"
                  :key="categoryName"
                  @click="changeTab(categoryName)"
              >{{ categoryObj.title }}
              </b-dropdown-item
              >
            </b-dropdown>
            <b-input-group class="input-group-merge" style="margin: 0">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon"/>
              </b-input-group-prepend>
              <b-form-input
                  id="searchbar"
                  v-model="faqSearchQuery"
                  placeholder="Search faq..."
                  @keyup.enter="keyEnter"
              />
            </b-input-group>
          </b-form>
          <!-- form -->
        </b-card-body>
      </b-card>
    </section>
    <!--/ faq search section -->

    <!-- frequently asked questions tabs pills -->
    <section id="faq-tabs">
      <faq-question-answer
          :options="fetchContent"
          :cate_id="cate_id"
          :title="faqSearchQuery"
          :key="new Date().getTime()"
      />
    </section>
    <!--/ frequently asked questions tabs pills -->

    <!--/ contact us -->
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BForm,
  BInputGroup,
  BFormInput,
  BCardText,
  BInputGroupPrepend,
  BTabs,
  BTab,
  BImg,
  BRow,
  BCol,
  BAvatar,
  BDropdown,
  BDropdownItem,
} from 'bootstrap-vue'
import axiosIns from '@/libs/axios'
import FaqQuestionAnswer from './FaqQuestionAnswer.vue'
import {
  ALL_CATEGORY_ID,
  LEGACY_ALL_CATEGORY_ID,
  filterBrochureArticles,
  filterBrochureCategories,
  sortCategoryList,
} from './brochuresHelpers'

export default {
  components: {
    BForm,
    BCard,
    BRow,
    BCol,
    BAvatar,
    BCardBody,
    BInputGroup,
    BFormInput,
    BCardText,
    BInputGroupPrepend,
    BTabs,
    BTab,
    BImg,
    FaqQuestionAnswer,
    BDropdown,
    BDropdownItem,
  },
  data() {
    return {
      tabsIndex: 0,
      faqSearchQuery: '',
      cate_id: 0,
      faqData: [],
      fetchContent: [],
      value: 'All',
      allCategoryId: ALL_CATEGORY_ID,
      brochureCategoryIds: [],
    }
  },
  watch: {
    faqSearchQuery: {
      immediate: true,
      handler() {
        // this.fetchDetails();
        // console.log(this.faqData);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.fetchData()
    })
  },
  methods: {
    keyEnter() {
      this.fetchDetails()
    },
    changedd(val) {
      // 设置鼠标忙碌
      this.fetchContent = []
      this.cate_id = this.faqData[val].id
      this.fetchDetails()
    },
    changeTab(index) {
      this.cate_id = this.faqData[index].id
      this.value = this.faqData[index].title
      this.fetchDetails()
    },
    filterArticles(list) {
      return filterBrochureArticles(list, this.brochureCategoryIds)
    },
    async fetchDetails() {
      const title = this.faqSearchQuery
      const pageSize = 10000
      const cateId = Number(this.cate_id)

      if (cateId === this.allCategoryId) {
        const categoryIds = this.brochureCategoryIds
        if (!categoryIds.length) {
          this.fetchContent = []
          return
        }

        const results = await Promise.all(
          categoryIds.map(id =>
            axiosIns.get('/article/list', { params: { cate_id: id, title, pageSize } })
          )
        )
        const merged = []
        const seen = new Set()
        results.forEach(res => {
          this.filterArticles(res.data?.list).forEach(item => {
            if (!seen.has(item.id)) {
              seen.add(item.id)
              merged.push(item)
            }
          })
        })
        this.fetchContent = merged
        return
      }

      axiosIns
        .get('/article/list', { params: { cate_id: this.cate_id, title, pageSize } })
        .then(res => {
          this.fetchContent = this.filterArticles(res.data?.list)
        })
    },
    fetchData() {
      axiosIns.get('/article/getArticleCateList', { params: { pageSize: 1000 } })
        .then((res) => {
          const categories = sortCategoryList(filterBrochureCategories(res.data.list))
          this.brochureCategoryIds = categories.map(c => c.id)
          this.faqData = [{ id: this.allCategoryId, title: 'All' }, ...categories]
          this.applyRouteQuery()
          this.fetchDetails()
        })
    },
    applyRouteQuery() {
      const { cate_id: queryCateId, title } = this.$route.query
      if (title) {
        this.faqSearchQuery = title
      }
      if (queryCateId !== undefined && queryCateId !== '') {
        const matched = this.faqData.find(c => String(c.id) === String(queryCateId))
        if (matched) {
          this.cate_id = matched.id
          this.value = matched.title
          return
        }
        if (String(queryCateId) === String(LEGACY_ALL_CATEGORY_ID)) {
          this.cate_id = this.allCategoryId
          this.value = 'All'
          return
        }
      }
      this.cate_id = this.faqData[0].id
      this.value = this.faqData[0].title
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-faq.scss";
</style>
